import attendanceRouter from "./attendanceRouter";
import leaveRouter from "./leaveRouter";
import leadRouter from "./leadRouter";
import financeRouter from "./financeRouter";
import taskRouter from "./taskRouter";
import assetRouter from "./assetRouter";
import employeeRouter from "./employeeRouter";
import settingRouter from "./settingRouter";
import rolesRouter from "./rolesRouter";
import divisionRouter from "./divisionRouter";
import departmentRouter from "./departmentRouter";
import designationRouter from "./designationRouter";
import usersRouter from "./usersRouter";
import noticeRouter from "./noticeRouter";
import notificationRouter from "./notificationRouter";
import payrollRouter from "./payrollRouter";
import subscriptionRouter from "./subscriptionRouter";
import subTaskRouter from "./subTaskRouter";
import loanRouter from "./loanRouter";
import outreachRouter from "./outreachRouter";
import dashboardRouter from "./dashboardRouter";

const allAdminRoutes = [
    ...dashboardRouter,
    ...usersRouter,
    ...employeeRouter,
    ...divisionRouter,
    ...departmentRouter,
    ...rolesRouter,
    ...designationRouter,
    ...attendanceRouter,
    ...leaveRouter,
    ...leadRouter,
    ...taskRouter,
    ...subTaskRouter,
    ...financeRouter,
    ...assetRouter,
    ...notificationRouter,
    ...noticeRouter,
    ...settingRouter,
    ...payrollRouter,
    ...loanRouter,
    ...subscriptionRouter,
    ...outreachRouter,
];

export default allAdminRoutes;
